module.exports = __webpack_public_path__ + "img/nodeType2.76bd5d78.svg";